<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item label="专家:">
                    <el-select v-model="formData.docname" placeholder="请选择" size="small" filterable clearable>
                        <el-option v-for="item in  formData.doc_options" :key="item.id" :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型:">
                    <el-select v-model="formData.doc_type" placeholder="请选择" size="small" filterable clearable>
                        <el-option v-for="item in  formData.type_options" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" icon="el-icon-s-promotion" :loading='submsgloading' size="small"
                        @click="submsg">推送消息</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="payee" label="专家" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="cash_fee" label="可提现金额" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="wait_amount" label="代入帐金额" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="a" label="扣款金额" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="phone" label="提现记录" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>
                            <el-button type="text" :disabled='scope.row.payee_type==3' @click="optxlist(scope.row)">查看
                            </el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!-- 查看专家提现记录 -->
        <el-dialog title="专家提现记录" :visible.sync="dialogVisible" center top="50px" width="70%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-table :data="tableDatatx" border v-loading="loading" ref="configurationTable1">
                    <el-table-column prop="amount" label="提现金额">
                        <template slot-scope="scope">{{scope.row.amount}}元</template>
                    </el-table-column>
                    <el-table-column prop="tax" label="税">
                        <template slot-scope="scope">{{scope.row.tax}}元</template>
                    </el-table-column>
                    <el-table-column prop="actual" label="实际到账">
                        <template slot-scope="scope">{{scope.row.actual}}元</template>
                    </el-table-column>
                    <el-table-column prop="bank.name" label="开户姓名" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bank.bank" label="银行名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bank.bank_outlets" label="银行网点" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bank.bank_card" label="收款账号" width="150" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="create_time" label="提现时间" width="180">
                        <template slot-scope="scope">
                            <span>{{date('Y-m-d H:i:s', scope.row.create_time) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="u-f u-ac u-jsb ft_mr">
                    <div></div>
                    <div>
                        <el-pagination @size-change="handleSizeChange_tx" @current-change="handleCurrentChange_tx"
                            :current-page="currentPage_tx" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize_tx"
                            layout="total, sizes, prev, pager, next, jumper" :total="count_tx">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData: {
                    time: '',
                    docname: '',
                    doc_options: [],
                    type_options:[
                        {id:1,name:'普通用户'},
                        {id:2,name:'医生'},
                        {id:3,name:'后台管理员'},
                    ],
                    doc_type:'',
                },
                loading: false,
                loading_tx: false,
                tableData: [],
                tableDatatx: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                currentPage_tx: 1,
                pagesize_tx: 15,
                count_tx: 0,
                heights: null,
                dialogVisible: false,
                date: xaoi.date,
                alluser: [],
                submsgloading: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getall()
            that.getHeight()
            that.getDate6()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 170 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 170 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/OrderLog/CashDetails", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        start_time: this.formData.time[0] ? this.formData.time[0] : '',
                        end_time: this.formData.time[1] ? this.formData.time[1] : '',
                        doc_id:this.formData.docname,
                        grantee_type:this.formData.doc_type,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            begin_gettx(row) {
                let that = this
                that.currentPage_tx = 1
                that.pagesize_tx = 15
                that.gettxlist(row)
            },
            gettxlist(row) {
                let that = this
                that.loading_tx = true
                axios
                    .post("/admin/pc/tools/pretax/withdrawal_list", {
                        page: that.currentPage_tx,
                        limit: that.pagesize_tx,
                        // start_time:this.formData.time[0]?this.formData.time[0]:'',
                        // end_time:this.formData.time[1]?this.formData.time[1]:'',
                        user_id: row.grantee_id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading_tx = false
                        that.tableDatatx = response.data.data.data
                        that.count_tx = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange_tx(val) {
                let that = this
                that.pagesize_tx = val;
                that.gettxlist()
            },
            handleCurrentChange_tx(val) {
                let that = this
                that.currentPage_tx = val;
                that.gettxlist()
            },
            getall() {
                this.getdoc()
            },
            getdoc() {
                axios
                    .post("/admin/doctorAssistantList", {}, {
                        token: true
                    })
                    .then(response => {
                        this.formData.doc_options = response.data.data
                    })
                    .catch(error => {})
            },

            optxlist(row) {
                this.dialogVisible = true
                this.begin_gettx(row)
            },
            //本月
            getDate6() {
                let that = this
                var date = new Date();
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                var start = date.getFullYear() + "-" + month + "-" + day;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = new Date(year, month, 0);
                var end = year + "-" + month + "-" + day.getDate();
                this.formData.time = [start, end]
                that.begin()
            },
            handleSelectionChange(val) {
                this.alluser = val
            },
            submsg() {
                if (this.alluser.length == 0) return this.$message.error('请选择要推送消息的专家')
                this.$confirm('此操作将推送一批提现消息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.submsgloading = true
                    let arrs=[]
                    this.alluser.forEach(ele=>{
                        arrs.push(ele.grantee_id)
                    })
                    axios
                        .post("/admin/pc/withdrawalPush", {
                            push_user_ids: arrs
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '成功!'
                                });
                                this.$nextTick(()=>{
                                  this.$refs.configurationTable.clearSelection();  
                                })
                            } else {
                                this.$message.error(response.data.msg)
                            }
                            this.submsgloading = false

                        })
                        .catch(error => {
                             this.submsgloading = false
                        })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },



        },

    };
</script>


<style>

</style>